// Remembers a form's scan for the life of the page.
//
// Generating the same blank form with the same ticked orders re-ran two AI
// calls per page and a "Reading the form…" spinner for an answer the browser
// already held. The backend deliberately never caches a TEMPLATE scan (it is
// shared by every clinic in the group, and its last fill belongs to someone
// else's patient); this cache is per browser tab, per user, so that concern
// does not apply here.
//
// Memory only, on purpose: a scan carries every page as a base64 image and
// sessionStorage would fill up. A reload starts clean, which is fine — the
// cost being avoided is the third and fourth generate of one sitting.

const scans = new Map();

/** Same path + same set of ids ⇒ same key, whatever order they were ticked in. */
export function formScanKey(path, orderIds) {
  const ids = [...(orderIds || [])].map(String).sort();
  return `${path || ""}|${ids.join(",")}`;
}

export function getFormScan(key) {
  return scans.get(key) || null;
}

export function setFormScan(key, response) {
  if (key && response) scans.set(key, response);
}

export function clearFormScans() {
  scans.clear();
}
